import React from 'react';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import BottomButtons from './BottomButtons';
import useMediaQuery from '@mui/material/useMediaQuery';
import {Theme} from './Theme';
import {Tools} from './Tools';
import {Inc,Plan,Item,Dataset,Owner} from './Inc';
import useStyles from './Styles';
import StoreImg from './StoreImg';

interface Props {
	isOpen:boolean,
    plan:Plan,
	owner:Owner,
    days:Dataset[],
    items:Item[],
    send():void,
    close(): void,
}

const PlanConfirm: React.FC<Props> = (props)=> {
    const classes = useStyles();
	const fullScreen = useMediaQuery(Theme.breakpoints.down('sm'));
	if(!props.isOpen){
		return (null);
	}
	return (
		<Dialog
			fullScreen={fullScreen}
			open={props.isOpen}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			disableEscapeKeyDown={true}
			onClose={(event: object, reason: string) =>{
				if( reason!=="backdropClick" ){
					props.close();
				}
			}}			
		>
			<DialogTitle color='primary'>発売日登録</DialogTitle>
			<DialogContent dividers>
				<div className={classes.confirmGuide}>
					この内容でよろしいですか？<br/>
					よろしかったら「登録する」を押して下さい。<br/>
				</div>
				<FormControl fullWidth={true} style={{marginBottom:"1.5em"}}>
					<FormLabel component="label" className={classes.formLabel}>商品</FormLabel>
					<List disablePadding>
					{props.items.map((item:Item,index:number)=>{
						const key = "item"+index;
						return (
							<ListItem key={key} style={{margin:'0.5em 0em',paddingRight:'0'}} dense>
								<ListItemAvatar style={{marginLeft:'-1em',marginRight:'1em'}}><StoreImg owner_id={props.owner.owner_id} img_id={item.img_id} thumb={true} className="imgList"/></ListItemAvatar>
								<ListItemText primary={(<><span className={classes.itemId}>ID:{item.item_id}</span><br/><span>{item.item_name}</span></>)} secondary=""/>
							</ListItem>
						)
					})}
					</List>
				</FormControl>

				<FormControl className={classes.formControl} fullWidth={true}>
					<FormLabel component="label" className={classes.formLabel}>発売日時</FormLabel>
					<div className={classes.formValue}>
						{Tools.getLabel(props.days,props.plan.plan_date)}　{props.plan.plan_hour}時
					</div>
				</FormControl>

				<FormControl className={classes.formControl} fullWidth={true}>
					<FormLabel component="label" className={classes.formLabel}>抽選期間</FormLabel>
					<div className={classes.formValue}>
						{Tools.getLabel(Inc.lotteryPeriods,String(props.plan.lottery_period))}
					</div>
				</FormControl>

				<FormControl className={classes.formControl} fullWidth={true}>
					<FormLabel component="label" className={classes.formLabel}>先行販売キー</FormLabel>
					<div className={classes.formValue}>
						{Tools.getLabel(Inc.uses,String(props.plan.prior_flag))}
					</div>
				</FormControl>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<BottomButtons button1='登録する' onClick1={props.send} button2='やりなおし' onClick2={props.close} top={0} bottom={0}/>
			</DialogActions>
        </Dialog>
	);
}

export default PlanConfirm;
